import styled, {keyframes} from 'styled-components';
import TestIMG from '../../../assets/broadcast/center-wait.jpg';

export const StreamingWrapper = styled.div`
    position: relative;
    width: 78vw;
    height: 89vh;
    overflow: hidden;
    background-color: #1c1c1c;
`;

export const StreamGrid = styled.div<{col: number; row: number}>`
    height: 100%;
    display: grid;
    grid-template-rows: repeat(${({col}) => col}, 1fr);
    grid-template-columns: repeat(${({row}) => row}, 1fr);
`;

export const BackgroundVideo = styled.div<{$isFullScreen: boolean; $isBroadCasting?: string | null}>`
    object-fit: cover;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    width: 100%;
    height: ${(props) => (props.$isBroadCasting ? '54.5rem' : '55rem')};
    border-radius: 1rem;
    position: relative;
    top: auto;
    left: auto;
    z-index: auto;

    ${(props) =>
        props.$isFullScreen &&
        `
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 100;
        border-radius: 0px;
    `}
    video, img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s ease-in-out;
    }
`;

export const ConnectionErrorOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 2;
    pointer-events: none;

    span {
        font-size: xx-large;
        font-weight: bolder;
        color: #fff;
    }
`;

// export const FullScreenIcon = styled.div<{ $isFullScreen: boolean, $show: boolean, $focused: boolean }>`
//     position: ${({$isFullScreen}) => ($isFullScreen ? "fixed" : "absolute")};;
//     bottom: 16px;
//     left: ${({$isFullScreen}) => ($isFullScreen ? "96vw" : "1400px")};
//     z-index: 999;
//     display: flex;
//     background-color: #1f1f1f;
//     padding: 0.7rem;
//     border-radius: 1.25rem;
//     transition: all 0.3s ease-in-out;
//     animation: ${({$show}) => ($show ? slideUp : slideDown)} 0.5s forwards;
//     width: 60px;
//     height: 60px;
//     border: ${({$focused}) => ($focused ? "3px solid #3FB5EC" : "none")};
// `;

export const PlayerWrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    overflow: hidden;
`;

const slideUp = keyframes`
    from {
        transform: translateY(200%);
    }
    to {
        transform: translateY(0);
    }
`;

const slideDown = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(200%);
    }
`;

export const LayoutButton = styled.div<{$isFullScreen: boolean; $show: boolean; $disable: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1f1f1f;
    padding: 0.7rem;
    border-radius: 1.25rem;
    transition: all 0.3s ease-in-out;
    animation: ${({$show}) => ($show ? slideUp : slideDown)} 0.5s forwards;

    opacity: ${({$disable}) => ($disable ? 0.4 : 1)};
    pointer-events: ${({$disable}) => ($disable ? 'none' : 'auto')};
    filter: ${({$disable}) => ($disable ? 'grayscale(80%)' : 'none')};
    cursor: ${({$disable}) => ($disable ? 'not-allowed' : 'pointer')};
`;

export const LayoutItem = styled.div<{$focused: boolean}>`
    width: 60px;
    height: 50px;
    display: flex;
    border: ${({$focused}) => ($focused ? '3px solid #3FB5EC' : 'none')};
    border-radius: 8px;
    justify-content: center;
`;

export const TestRedIcon = styled.div`
    width: 50px;
    height: 50px;
    position: fixed;
    top: 5vh;
    left: 3vw;
    border-radius: 30px;
    background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

export const SplashImg = styled.div<{$show: boolean}>`
    position: absolute;
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
    background-image: url(${TestIMG});
    z-index: 100;
    transition: all 0.3s ease-in-out;
    animation: ${({$show}) => ($show ? fadeIn : fadeOut)} 0.5s forwards;
`;

export const PleaseWaitText = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: xx-large;
    font-weight: bolder;
`;
